import React, { useEffect } from 'react';

const ImageModal = ({ isOpen, imageUrl, altText, onClose }) => {
  // Handle body scroll lock when modal is open
  useEffect(() => {
    if (isOpen) {
      // Get the current scrollbar width
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      
      // Disable scrolling but maintain page width by adding padding equal to scrollbar width
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      
      // Reset styles when modal closes
      return () => {
        document.body.style.overflow = 'auto';
        document.body.style.paddingRight = '0px';
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
      tabIndex={0}
      autoFocus
    >
      <div 
        className="bg-white p-4 rounded-lg max-w-4xl relative h-4/5 flex flex-col items-center justify-center overflow-hidden"
        onClick={e => e.stopPropagation()}
      >
        <button 
          onClick={onClose}
          className="absolute top-2 right-2 bg-gray-200 text-gray-700 hover:bg-gray-300 hover:text-gray-900 p-1 rounded-full w-8 h-8 flex items-center justify-center z-10"
          aria-label="Close"
        >
          ×
        </button>
        <div className="overflow-auto h-full w-full flex items-center justify-center">
          <img 
            src={imageUrl} 
            className="max-h-full max-w-full object-contain" 
            alt={altText || "Image"}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageModal;